import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl bg-card border-border shadow-glow">
        <CardContent className="text-center p-8 lg:p-12">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img
              src="/images/autoclipper-logo-full.png"
              alt="Autoclipper Logo"
              className="h-16 w-auto"
            />
          </div>

          {/* 404 with gradient styling */}
          <div className="mb-6">
            <h1 className="text-8xl lg:text-9xl font-bold bg-gradient-primary bg-clip-text text-transparent mb-4">
              404
            </h1>
            <div className="w-24 h-1 bg-gradient-primary mx-auto rounded-full"></div>
          </div>

          {/* Error message */}
          <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-4">
            {t('notFound.title')}
          </h2>
          <p className="text-muted-foreground text-lg mb-8 max-w-md mx-auto">
            {t('notFound.description')}
          </p>

          {/* Action buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              asChild
              variant="gradient"
              size="lg"
              className="w-full sm:w-auto"
            >
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                {t('notFound.backToHome')}
              </Link>
            </Button>

            <Button
              asChild
              variant="outline"
              size="lg"
              className="w-full sm:w-auto"
            >
              <button onClick={() => window.history.back()}>
                <ArrowLeft className="w-4 h-4 mr-2" />
                {t('notFound.previousPage')}
              </button>
            </Button>
          </div>

          {/* Additional help text */}
          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-sm text-muted-foreground">
              {t('notFound.needHelp')}{" "}
              <Link
                to="https://chat.whatsapp.com/BV9LMJnV2gV5DQbpt5ZNoA?s=cl&p=i&mlu=4"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-primary/80 underline"
              >
                {t('notFound.whatsAppCommunity')}
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
